var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollbar slide-in-scroller from-right slide-panel ss-light-grey-bg u-height-100vh",class:{SidePanelWithIframe: _vm.sidePanel.isSidePanelFrame},on:{"click":_vm.hideDropdown}},[_c('div',{staticClass:"slide-in-content"},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"sidepanel"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }